exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vue-full-screen-file-drop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 10000;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0,0,0,0.4);\n  visibility: hidden;\n  opacity: 0;\n  transition: visibility 200ms, opacity 200ms;\n}\n.vue-full-screen-file-drop--visible {\n  opacity: 1;\n  visibility: visible;\n}\n.content {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  color: #fff;\n  font-size: 2em;\n}\n", ""]);

// exports
